module.exports = __webpack_public_path__ + "components/tide-table/static/moon-last-quarter-b6b3cba517bdc5ac343a21032fa795e9.svg";